import { z } from 'zod'

// ============================================
// 服务记录表单验证 Schema（录入/编辑共用；编辑时 customer_id 仅作展示锁定）
// ============================================
export const serviceRecordFormSchema = z.object({
	customer_id: z
		.number({ message: '请选择客户' })
		.int({ message: '请选择客户' })
		.positive({ message: '请选择客户' }),
	type_ids: z
		.array(z.number().int())
		.min(1, { message: '请选择至少一个服务类型' }),
	subject: z
		.string()
		.min(1, { message: '请填写服务主题' })
		.max(255, { message: '服务主题不能超过 255 字' }),
	content: z
		.string()
		.max(5000, { message: '服务内容不能超过 5000 字' }),
	images: z.array(z.string()),
	next_service_at: z
		.string()
		.min(1, { message: '请选择下次回访时间' }),
	category_id: z.string(),
})

export type ServiceRecordFormValues = z.infer<typeof serviceRecordFormSchema>
